import React, { useEffect, useState } from "react";
import { RenderMarkdownWithLatex } from "../../utils/utils"; // Upewnij się, że ścieżka jest poprawna
import ReportIssueModal from "./ReportIssueModal"; // Upewnij się, że ścieżka jest poprawna

// Importy dla funkcjonalności AI
import AiChatPopup from "../molecules/AiChatPopup"; // Upewnij się, że ścieżka jest poprawna
import CorrectionModal from "./CorrectionModal"; // Upewnij się, że ścieżka jest poprawna
import {
  startChatAndGenerateSolution,
  continueChat,
} from "../../services/geminiService"; // Upewnij się, że ścieżka jest poprawna

const apiUrl = process.env.REACT_APP_API_SOURCE;
const token = localStorage.getItem("token");


/**
 * Komponent wyświetlający pojedynczy problem w trybie testowym (bez interakcji)
 */
const ProblemDisplayForTest = ({
  problem,
  index,
  totalProblems,
  onReportIssue,
  onAskAI, // Prop dla "Zapytaj AI"
  onCorrectIssueRequest, // Prop dla "Popraw Zadanie"
}) => {
  const [imageLoadError, setImageLoadError] = useState(false);
  const imageUrl = problem.image_link
    ? (problem.image_link.startsWith('http') ? problem.image_link : `${process.env.REACT_APP_STATIC_FILES_SOURCE || ''}/images/${problem.image_link}`)
    : null;

  const answers = [
    { text: problem.true_answer, isCorrect: true },
    { text: problem.false_answer1, isCorrect: false },
    { text: problem.false_answer2, isCorrect: false },
    { text: problem.false_answer3, isCorrect: false },
  ].filter(ans => ans && ans.text);

  return (
    <div className="problem-container border border-gray-300 rounded-lg p-4 sm:p-6 mb-6 shadow-sm bg-white relative">
      <div className="mb-3 pb-2 border-b border-gray-200">
        <h3 className="text-md sm:text-lg font-semibold text-gray-700">
          Zadanie {index + 1} z {totalProblems}
        </h3>
        <p className="text-xs text-gray-400 mt-0.5">ID: {problem.problem_id} (PT_ID: {problem.problem_translation_id || problem.problem_id})</p>
        <p className={`text-xs font-medium mt-1 ${problem.is_mobile ? 'text-green-600' : 'text-orange-600'}`}>
          Zadanie bez obliczeń: {problem.is_mobile ? 'Tak' : 'Nie'}
        </p>
      </div>

      <div className="mb-4 text-gray-900 text-[1.0rem] sm:text-[1.06rem] leading-relaxed">
        <RenderMarkdownWithLatex text={problem.question || "Brak treści pytania."} />
      </div>

      {imageUrl && !imageLoadError && (
        <div className="flex justify-center my-4">
          <img
            src={imageUrl}
            alt={`Ilustracja do zadania ${problem.problem_id}`}
            className="max-w-full h-auto rounded border border-gray-300"
            onError={() => {
              console.warn(`Nie udało się załadować obrazka: ${imageUrl}`);
              setImageLoadError(true);
            }}
          />
        </div>
      )}
      {imageLoadError && (
        <p className="text-red-600 text-sm my-2 text-center">Błąd podczas ładowania obrazka.</p>
      )}

      {answers.length > 0 && (
        <div className="mt-5">
          <h4 className="font-semibold text-sm text-gray-600 mb-2">Odpowiedzi:</h4>
          <div className="space-y-2">
            {answers.map((answer, i) => (
              <div
                key={i}
                className={`p-3 border rounded text-sm ${
                  answer.isCorrect
                    ? "bg-green-50 border-green-300 text-green-800 font-medium"
                    : "bg-gray-50 border-gray-200 text-gray-800"
                }`}
              >
                <RenderMarkdownWithLatex text={answer.text} />
              </div>
            ))}
          </div>
        </div>
      )}

      {problem.hint && (
          <details className="mt-4 bg-gray-50 rounded border border-gray-200 p-3" open>
            <summary className="font-semibold text-sm text-gray-600 cursor-pointer hover:text-gray-800 transition-colors">Podpowiedź:</summary>
            <div className="mt-2 text-sm text-gray-700">
                <RenderMarkdownWithLatex text={problem.hint} />
            </div>
          </details>
      )}

      {problem.solution && (
          <details className="mt-2 bg-blue-50 rounded border border-blue-200 p-3" open>
            <summary className="font-semibold text-sm text-blue-700 cursor-pointer hover:text-blue-800 transition-colors">Rozwiązanie:</summary>
            <div className="mt-2 text-sm text-gray-700">
                <RenderMarkdownWithLatex text={problem.solution} />
            </div>
          </details>
      )}

      {/* Przyciski Akcji */}
      <div className="absolute top-3 right-3 flex flex-col space-y-1 sm:flex-row sm:space-y-0 sm:space-x-1 sm:items-center">
        {onAskAI && (
            <button
              onClick={() => onAskAI(problem)}
              title="Zapytaj AI o to zadanie"
              className="text-xs bg-indigo-100 text-indigo-700 hover:bg-indigo-200 px-2 py-1 rounded border border-indigo-300 transition-colors duration-150 shadow-sm whitespace-nowrap"
            >
              Zapytaj AI
            </button>
        )}
        {onCorrectIssueRequest && (
            <button
                onClick={() => onCorrectIssueRequest(problem)}
                title="Popraw zadanie z pomocą AI (poziom studiów)"
                className="text-xs bg-yellow-100 text-yellow-700 hover:bg-yellow-200 px-2 py-1 rounded border border-yellow-300 transition-colors duration-150 shadow-sm whitespace-nowrap"
            >
                Popraw Zad.
            </button>
        )}
        {onReportIssue && (
            <button
              onClick={() => onReportIssue(problem.problem_id, problem.field_id)}
              title="Zgłoś błąd tego zadania"
              className="text-xs bg-red-100 text-red-700 hover:bg-red-200 px-2 py-1 rounded border border-red-300 transition-colors duration-150 shadow-sm whitespace-nowrap"
            >
              Zgłoś Błąd
            </button>
        )}
      </div>
    </div>
  );
};

/**
 * Główny komponent ekranu do testowania renderowania zadań
 */
const ProblemRenderTestScreen = () => {
  const [fields, setFields] = useState([]);
  const [selectedField, setSelectedField] = useState("");
  const [subfields, setSubfields] = useState([]);
  const [selectedSubfield, setSelectedSubfield] = useState("");
  const [problems, setProblems] = useState([]);
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [loadingProblems, setLoadingProblems] = useState(false);
  const [error, setError] = useState(null);
  const [mobileFilter, setMobileFilter] = useState('all');

  // Stan dla Modala Zgłaszania Błędów
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportingProblemData, setReportingProblemData] = useState(null);

  // Stany dla Modala "Popraw Zadanie"
  const [isCorrectionModalOpen, setIsCorrectionModalOpen] = useState(false);
  const [currentProblemForCorrection, setCurrentProblemForCorrection] = useState(null);
  const [aiCorrectedData, setAiCorrectedData] = useState(null);
  const [isRequestingCorrection, setIsRequestingCorrection] = useState(false);
  const [isAcceptingCorrection, setIsAcceptingCorrection] = useState(false);
  const [correctionError, setCorrectionError] = useState(null);

  // Stany dla Modala "Zapytaj AI" (Czat Ogólny)
  const [isGeneralAiChatOpen, setIsGeneralAiChatOpen] = useState(false);
  const [currentProblemForGeneralAiChat, setCurrentProblemForGeneralAiChat] = useState(null);
  const [generalAiChatHistory, setGeneralAiChatHistory] = useState([]);
  const [isGeneralAiResponding, setIsGeneralAiResponding] = useState(false);
  const [problemSpecificChatHistories, setProblemSpecificChatHistories] = useState({});

  useEffect(() => {
    const fetchFields = async () => {
      setLoadingConfig(true);
      setError(null);
      try {
        const response = await fetch(`${apiUrl}problems_config_test/?lang=pl`, { // Endpoint dla konfiguracji
          headers: { "Content-Type": "application/json", Authorization: `Token ${token}` }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        setFields(data);
      } catch (e) {
        console.error("Nie udało się pobrać konfiguracji pól:", e);
        setError("Nie udało się pobrać konfiguracji pól.");
      } finally { setLoadingConfig(false); }
    };
    if (token) fetchFields();
    else { setError("Brak tokena autoryzacyjnego. Zaloguj się."); setLoadingConfig(false); }
  }, [token]);

  useEffect(() => {
    if (selectedField) {
      const fieldData = fields.find((f) => f.field_id === parseInt(selectedField));
      setSubfields(fieldData ? fieldData.subfields : []);
      setSelectedSubfield("");
      setProblems([]);
    } else {
      setSubfields([]);
      setSelectedSubfield("");
      setProblems([]);
    }
  }, [selectedField, fields]);

  const handleFetchProblems = async () => {
    if (!selectedSubfield) { alert("Proszę wybrać poddział."); return; }
    if (!token) { alert("Brak tokena autoryzacyjnego. Zaloguj się."); return; }
    setLoadingProblems(true);
    setProblems([]);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}problems_list_test/?subfield_id=${selectedSubfield}&lang=pl`, { // Endpoint dla listy zadań testowych/studia
        headers: { "Content-Type": "application/json", Authorization: `Token ${token}` }
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setProblems(data.map(p => ({ ...p, problem_translation_id: p.problem_translation_id || p.problem_id })));
      if (data.length === 0) setError("Nie znaleziono zadań dla wybranego poddziału.");
    } catch (e) {
      console.error("Nie udało się pobrać zadań:", e);
      setError("Nie udało się pobrać zadań.");
    } finally { setLoadingProblems(false); }
  };

  const handleReportIssue = (problemId, fieldId) => {
    setReportingProblemData({ problem_id: problemId, field_id: fieldId });
    setIsReportModalOpen(true);
  };
  const handleCloseReportModal = () => {
    setIsReportModalOpen(false);
    setReportingProblemData(null);
  };

  // --- Obsługa "Popraw Zadanie" (dla poziomu studiów) ---
  const handleCorrectIssueRequest_Studies = async (problem) => {
    // ✨ NOWA CZĘŚĆ - ZBIERANIE INSTRUKCJI OD UŻYTKOWNIKA ✨
    const userInstructions = window.prompt(
        "Wpisz dodatkowe instrukcje dla AI (np. 'Uprość język', 'Skoncentruj się na błędach w formule').\n\nNaciśnij Anuluj, aby wysłać bez instrukcji.",
        "" // Domyślna wartość w polu tekstowym
    );
  
    // Jeśli użytkownik kliknie "Anuluj", prompt zwraca null. Przerywamy działanie.
    if (userInstructions === null) {
        console.log("Korekta anulowana przez użytkownika.");
        return;
    }
    
    const problemIdForCorrection = problem.problem_translation_id || problem.problem_id;
    if (!problemIdForCorrection) {
      alert("Brak ID zadania do korekty."); return;
    }
    setCurrentProblemForCorrection(problem);
    setIsRequestingCorrection(true);
    setCorrectionError(null);
    setAiCorrectedData(null);
    try {
      const problemDataPayload = {
        problem_translation_id: problemIdForCorrection,
        question: problem.question,
        true_answer: problem.true_answer,
        false_answer1: problem.false_answer1,
        false_answer2: problem.false_answer2,
        false_answer3: problem.false_answer3,
        hint: problem.hint,
        solution: problem.solution,
        context_level: "studies",
        user_instructions: userInstructions, // ✨ PRZEKAZANIE INSTRUKCJI DO API
      };
      const response = await fetch(`${apiUrl}correct_problem_content/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${token}` },
        body: JSON.stringify(problemDataPayload),
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({ detail: "Błąd serwera przy korekcie (studia)." }));
        throw new Error(errData.detail || `Błąd serwera: ${response.status}`);
      }
      const data = await response.json();
      setAiCorrectedData(data);
      setIsCorrectionModalOpen(true);
    } catch (e) {
      console.error("Błąd żądania korekty AI (studia):", e);
      setCorrectionError(`Nie udało się uzyskać korekty (studia): ${e.message}`);
    } finally { setIsRequestingCorrection(false); }
  };

  const handleAcceptCorrection_Studies = async () => {
    if (!aiCorrectedData || !currentProblemForCorrection) {
      setCorrectionError("Brak danych do akceptacji korekty (studia)."); return;
    }
    const problemIdToUpdate = currentProblemForCorrection.problem_translation_id || currentProblemForCorrection.problem_id;
    if (!problemIdToUpdate) {
        setCorrectionError("Brak ID zadania do aktualizacji (studia)."); return;
    }
    setIsAcceptingCorrection(true);
    setCorrectionError(null);
    try {
      const response = await fetch(`${apiUrl}problem_translation/${problemIdToUpdate}/update_corrected/`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${token}` },
        body: JSON.stringify(aiCorrectedData), // Przesyłamy dane zwrócone przez AI
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({ detail: "Błąd serwera przy aktualizacji (studia)." }));
        throw new Error(errData.detail || `Błąd serwera: ${response.status}`);
      }
      // Aktualizacja zadania w lokalnym stanie `problems`
      setProblems(prevProblems =>
        prevProblems.map(p => {
          const currentPId = p.problem_translation_id || p.problem_id;
          if (currentPId === problemIdToUpdate) {
            // Mapowanie pól zwróconych przez AI na pola obiektu problemu
            return { 
                ...p, 
                question: aiCorrectedData.corrected_question, 
                true_answer: aiCorrectedData.corrected_true_answer, 
                false_answer1: aiCorrectedData.corrected_false_answer1, 
                false_answer2: aiCorrectedData.corrected_false_answer2, 
                false_answer3: aiCorrectedData.corrected_false_answer3, 
                hint: aiCorrectedData.corrected_hint, 
                solution: aiCorrectedData.corrected_solution 
            };
          }
          return p;
        })
      );
      setIsCorrectionModalOpen(false);
      setAiCorrectedData(null);
      setCurrentProblemForCorrection(null);
      alert("Zadanie (studia) zostało zaktualizowane!");
    } catch (e) {
      console.error("Błąd akceptacji korekty (studia):", e);
      setCorrectionError(`Nie udało się zaktualizować zadania (studia): ${e.message}`);
    } finally { setIsAcceptingCorrection(false); }
  };
  const handleCloseCorrectionModal_Studies = () => {
    setIsCorrectionModalOpen(false);
    setAiCorrectedData(null);
    setCurrentProblemForCorrection(null);
    setCorrectionError(null);
  };

  // --- Obsługa "Zapytaj AI" (Czat Ogólny) ---
  const handleAskGeneralAI = async (problem) => {
    setCurrentProblemForGeneralAiChat(problem);
    setIsGeneralAiChatOpen(true);
    const problemIdForChat = problem.problem_translation_id || problem.problem_id;
    const existingHistory = problemSpecificChatHistories[problemIdForChat] || [];
    setGeneralAiChatHistory(existingHistory);

    if (existingHistory.length > 0 || isGeneralAiResponding) return;

    setIsGeneralAiResponding(true);
    try {
      let initialUserMessageForAI = `Mam pytanie dotyczące następującego zadania akademickiego (ID: ${problem.problem_id}):\nTreść: "${problem.question}".`;
      if (problem.true_answer) initialUserMessageForAI += `\nPoprawna odpowiedź to: "${problem.true_answer}".`;
      if (problem.solution) initialUserMessageForAI += `\nPodane rozwiązanie: "${problem.solution}".`;
      initialUserMessageForAI += `\n\nProszę o wyjaśnienie lub pomoc w zrozumieniu tego zagadnienia. Co mogę dla Ciebie zrobić, abyś mógł mi pomóc?`;
      
      const { updatedHistory } = await startChatAndGenerateSolution(
        initialUserMessageForAI,
        null, 
        problem.true_answer, 
        process.env.REACT_APP_GEMINI_API_KEY
      );
      setGeneralAiChatHistory(updatedHistory);
      setProblemSpecificChatHistories(prev => ({ ...prev, [problemIdForChat]: updatedHistory }));
    } catch (err) {
      console.error("Błąd inicjowania czatu AI (studia):", err);
      setGeneralAiChatHistory([{ role: 'model', parts: [{ text: "Przepraszam, wystąpił błąd podczas łączenia z AI (studia)." }] }]);
    } finally { setIsGeneralAiResponding(false); }
  };

  const handleSendGeneralChatMessage = async (message) => {
    if (!currentProblemForGeneralAiChat) return;
    const problemIdForChat = currentProblemForGeneralAiChat.problem_translation_id || currentProblemForGeneralAiChat.problem_id;
    const currentStoredHistory = problemSpecificChatHistories[problemIdForChat] || [];
    
    const provisionalUserMsg = { role: "user", parts: [{ text: message }] };
    setGeneralAiChatHistory([...currentStoredHistory, provisionalUserMsg]);
    
    setIsGeneralAiResponding(true);
    try {
      const { updatedHistory } = await continueChat(
        currentStoredHistory,
        message,
        process.env.REACT_APP_GEMINI_API_KEY
      );
      setGeneralAiChatHistory(updatedHistory);
      setProblemSpecificChatHistories(prev => ({ ...prev, [problemIdForChat]: updatedHistory }));
    } catch (err) {
      console.error("Błąd wysyłania wiadomości AI (studia):", err);
      setGeneralAiChatHistory(prev => [...prev, { role: 'model', parts: [{ text: "Niestety, wystąpił błąd odpowiedzi AI (studia)." }] }]);
    } finally { setIsGeneralAiResponding(false); }
  };

  const handleCloseGeneralAiChat = () => {
    setIsGeneralAiChatOpen(false);
  };

  // Filtrowanie problemów
  const filteredProblems = problems.filter(problem => {
    if (mobileFilter === 'mobile') return problem.is_mobile === true;
    if (mobileFilter === 'non-mobile') return problem.is_mobile === false;
    return true;
  });

  return (
    <div className="container mx-auto px-4 py-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-gray-800 border-b pb-2">
        Test Renderowania Zadań (Poziom Studiów)
      </h1>

      {/* Globalne wskaźniki ładowania AI */}
      {isRequestingCorrection && <p className="fixed top-5 left-1/2 -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded shadow-lg z-[100]">AI Poprawia Zadanie...</p>}
      {isGeneralAiResponding && !isGeneralAiChatOpen && <p className="fixed top-5 left-1/2 -translate-x-1/2 bg-indigo-500 text-white px-4 py-2 rounded shadow-lg z-[100]">AI Myśli (Czat)...</p>}

      {/* Sekcja wyboru Field/Subfield/Mobile */}
      <div className="bg-white p-4 rounded-lg shadow mb-6">
        <h2 className="text-lg font-semibold mb-3 text-gray-700">Wybierz zakres zadań</h2>
        {loadingConfig && <p className="text-blue-600">Ładowanie konfiguracji...</p>}
        {error && !loadingConfig && <p className="text-red-600 mb-2">{error}</p>}
        <div className="flex flex-wrap items-center gap-4">
          <select value={selectedField} onChange={(e) => setSelectedField(e.target.value)} className="border border-gray-300 rounded p-2 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={loadingConfig || !token}>
            <option value="">--- Wybierz Dział ---</option>
            {fields.map((field) => (<option key={field.field_id} value={field.field_id}>{field.field_name} ({field.knowledge_level})</option>))}
          </select>
          <select value={selectedSubfield} onChange={(e) => setSelectedSubfield(e.target.value)} className="border border-gray-300 rounded p-2 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={!selectedField || subfields.length === 0 || !token}>
            <option value="">--- Wybierz Poddział ---</option>
            {subfields.map((subfield) => (<option key={subfield.subfield_id} value={subfield.subfield_id}>{subfield.subfield_name}</option>))}
          </select>
          <select value={mobileFilter} onChange={(e) => setMobileFilter(e.target.value)} className="border border-gray-300 rounded p-2 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={loadingProblems || loadingConfig || !token}>
            <option value="all">Wszystkie (Mobile/Non-Mobile)</option>
            <option value="mobile">Tylko Mobilne</option>
            <option value="non-mobile">Tylko Nie-Mobilne</option>
          </select>
          <button onClick={handleFetchProblems} className="bg-blue-600 text-white px-4 py-2 rounded font-semibold hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50" disabled={!selectedSubfield || loadingProblems || loadingConfig || !token || isRequestingCorrection || (isGeneralAiResponding && !isGeneralAiChatOpen)}>
            {loadingProblems ? "Ładowanie zadań..." : "Pobierz Zadania"}
          </button>
        </div>
      </div>

      {/* Sekcja wyświetlania zadań */}
      <div className="mt-6">
        {loadingProblems && <p className="text-blue-600 text-center py-4">Ładowanie zadań...</p>}
        {error && !loadingProblems && problems.length === 0 && <p className="text-red-600 mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">{error}</p>}
        
        {!loadingProblems && problems.length > 0 && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg text-blue-800">
            Liczba wyświetlonych zadań (po filtrze): <span className="font-bold">{filteredProblems.length}</span>
            {problems.length !== filteredProblems.length && (<span className="text-sm text-gray-600"> (z {problems.length} załadowanych)</span>)}
          </div>
        )}

        {!loadingProblems &&
          filteredProblems.map((problem, index) => (
            <ProblemDisplayForTest
              key={problem.problem_id}
              problem={problem}
              index={index}
              totalProblems={filteredProblems.length}
              onReportIssue={handleReportIssue}
              onAskAI={handleAskGeneralAI}
              onCorrectIssueRequest={handleCorrectIssueRequest_Studies}
            />
          ))}

        {!loadingConfig && !loadingProblems && problems.length > 0 && filteredProblems.length === 0 && !error && (
          <p className="text-gray-500 mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">Brak zadań spełniających wybrane kryteria filtrowania.</p>
        )}
        {!loadingConfig && !loadingProblems && problems.length === 0 && selectedSubfield && !error && (
          <p className="text-gray-500 p-3 bg-gray-50 border border-gray-200 rounded-lg">Brak zadań dla wybranego poddziału.</p>
        )}
      </div>

      {/* Renderowanie Modali */}
      {isReportModalOpen && reportingProblemData && (
        <ReportIssueModal
          onClose={handleCloseReportModal}
          reportIssueData={reportingProblemData}
        />
      )}
      {isCorrectionModalOpen && currentProblemForCorrection && aiCorrectedData && (
        <CorrectionModal
          isOpen={isCorrectionModalOpen}
          onClose={handleCloseCorrectionModal_Studies}
          originalProblem={currentProblemForCorrection}
          correctedData={aiCorrectedData}
          onAcceptCorrection={handleAcceptCorrection_Studies}
          isAccepting={isAcceptingCorrection}
          error={correctionError}
        />
      )}
      {isGeneralAiChatOpen && currentProblemForGeneralAiChat && (
        <AiChatPopup
          isOpen={isGeneralAiChatOpen}
          onClose={handleCloseGeneralAiChat}
          chatTitle={`Pytanie o zadanie ID: ${currentProblemForGeneralAiChat.problem_id}`}
          chatHistory={generalAiChatHistory}
          onSendMessage={handleSendGeneralChatMessage}
          isResponding={isGeneralAiResponding}
          problemQuestion={currentProblemForGeneralAiChat.question}
        />
      )}
    </div>
  );
};

export default ProblemRenderTestScreen;